/**
 * Kingspan - Expivi 3D Modal
 *
 * Two buttons on PDP:
 *   "Build in 3D" → full-screen modal, all options, add to cart, no preset
 *   "View in 3D"  → windowed modal, loads tank model preset only
 *                   (region + colour chosen inside the viewer, not from PDP)
 *
 * Preset mapping is defined in expivi-kingspan-config.js.
 * The configurator URL is read from the existing Expivi "Configure" button.
 * CSS is injected into the srcdoc via expivi-kingspan.css.
 */
(function () {
  'use strict';

  // Guard: this script is loaded globally from theme.liquid (via the modal shell)
  // AND, on the Slimline template, also by a per-template Custom Liquid block.
  // Run the wiring only once if both are present.
  if (window.__expivi3dModalLoaded) return;
  window.__expivi3dModalLoaded = true;

  // Self-inject the "View in 3D" / "Build in 3D" buttons when the template did not
  // render them. The modal shell is global (all products tagged "3d"), but the buttons
  // used to live in a per-template Custom Liquid block that only the Slimline template
  // had — so Modline/Square/Round got the modal but no way to open it. Injecting here
  // makes every tagged product work with zero per-template setup. Idempotent: if the
  // template already printed the buttons (Slimline), we leave them and just bind below.
  injectButtonsIfMissing();

  function injectButtonsIfMissing() {
    if (document.getElementById('expivi-build-3d-trigger')) return; // already rendered by template
    if (!document.getElementById('expivi-3d-modal')) return;  // not a 3d product page
    // Anchor: the Dawn price block, so the buttons sit right under the price (same spot
    // the Slimline template places them).
    var priceBlock = document.querySelector('.product__info-container [id^="price-template--"]')
                  || document.querySelector('[id^="price-template--"]')
                  || document.querySelector('.product__info-container .price');
    if (!priceBlock) return;
    var row = document.createElement('div');
    row.className = 'expivi-buttons-row';
    row.innerHTML =
      '<button id="expivi-build-3d-trigger" class="expivi-btn expivi-btn--primary" type="button">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>' +
        'Build in 3D' +
      '</button>';
    priceBlock.insertAdjacentElement('afterend', row);
  }

  var modal        = document.getElementById('expivi-3d-modal');
  var buildTrigger = document.getElementById('expivi-build-3d-trigger');
  var viewTrigger  = document.getElementById('expivi-3d-trigger');
  var closeBtn     = document.getElementById('expivi-modal-close');
  var iframe       = document.getElementById('expivi-configurator-iframe');
  var loadingEl    = document.getElementById('expivi-loading');
  var modalInner   = modal ? modal.querySelector('.expivi-modal') : null;

  if (!modal || !iframe) return;

  // Read configurator URL from the existing Expivi "Configure" button.
  // Strip the "currency" param — it triggers a /services/currency/update redirect
  // that returns 404 on Shopify preview domains.
  var configureLink = document.querySelector('a[href*="/apps/configurator"]');
  var baseUrl = '';
  if (configureLink) {
    try {
      var _u = new URL(configureLink.getAttribute('href'), window.location.origin);
      _u.searchParams.delete('currency');
      baseUrl = _u.pathname + (_u.search ? _u.search : '');
    } catch (e) {
      baseUrl = configureLink.getAttribute('href');
    }
  }
  // Fallback: all Kingspan tanks share one Expivi catalogue, so if no "Configure"
  // link is present on the page we point the iframe at it directly. Keeps the JS
  // self-sufficient on templates that don't render the hidden link.
  if (!baseUrl) baseUrl = '/apps/configurator?catalogue=7289956859984';
  var cssUrl        = modal.getAttribute('data-css-url') || '';
  var productId     = parseInt(modal.getAttribute('data-product-id'), 10);

  // Resolve preset for this product from config file
  var config  = (window.KingspanExpiviConfig || {}).products || {};
  var preset  = (config[productId] || {}).preset || '';

  // Derive the base preset identifier from a SKU.
  // Product SKUs follow the convention: PREFIX-<numeric dimension groups>[-LETTER_SUFFIX...]
  // The Expivi preset is named exactly as the base (prefix + numeric groups), so we strip any
  // trailing letter suffix (e.g. -FT fire tank, -TP tank+pump bundle, or any future suffix).
  //   SL-1150-3300-2020      -> SL-1150-3300-2020   (already base, 1:1)
  //   SL-1150-3300-2020-TP   -> SL-1150-3300-2020
  //   ML-1150-4000-2250-FT   -> ML-1150-4000-2250
  //   RD-2700-1860-FT        -> RD-2700-1860        (round: PREFIX-diameter-height)
  function deriveBasePresetSku(s) {
    if (!s) return '';
    var seg = s.split('-');
    var out = [seg[0]];                              // prefix (letters)
    for (var i = 1; i < seg.length; i++) {
      if (/^\d+$/.test(seg[i])) out.push(seg[i]);    // keep numeric dimension groups
      else break;                                    // first non-numeric segment -> suffix starts
    }
    return out.join('-');
  }

  // SKU-based preset preload. Resolution order:
  //   1) presetBySku[<SKU>]      — explicit override for SKUs that break the naming convention
  //   2) deriveBasePresetSku()   — strip the letter suffix to get the base SKU == preset name
  //                                (covers both 1:1 base SKUs and -FT/-TP/etc. variants, no map needed)
  //   3) preset                  — legacy per-product fallback (above)
  var sku         = (modal.getAttribute('data-sku') || '').trim();
  var presetBySku = (window.KingspanExpiviConfig || {}).presetBySku || {};
  var presetKey   = (sku && presetBySku[sku]) || deriveBasePresetSku(sku) || preset;

  // ─── Preset loading ───────────────────────────────────────

  function applyPreset(presetKey) {
    var win = iframe.contentWindow;
    var attempts = 0;
    var maxAttempts = 60; // 60 × 500ms = 30s

    var interval = setInterval(function () {
      attempts++;
      try {
        var apiReady   = win && win.expivi && typeof win.expivi.loadConfiguration === 'function';
        var hasOnReady = apiReady && win.expivi._events && win.expivi._events.onReady;

        if (hasOnReady) {
          clearInterval(interval);

          var sub = win.expivi._events.onReady.subscribe(function () {
            if (sub) sub.unsubscribe();

            var apiToken = win.expivi.apiToken;
            if (!presetKey || !apiToken) return;

            // Direct preset lookup by identifier (the SKU). Using find/{slug} instead of the
            // catalogue ?include=presets map avoids pagination once there are many presets (~81).
            fetch('https://expivi.net/api/product_preset/find/' + encodeURIComponent(presetKey) + '?include=constraints', {
              headers: { 'Authorization': 'Bearer ' + apiToken }
            })
              .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
              })
              .then(function (d) {
                var cfg = d && d.data && d.data.attributes && d.data.attributes.configuration;
                if (!cfg) {
                  console.warn('Expivi: No preset found for "' + presetKey + '"');
                  return;
                }
                return win.expivi.loadConfiguration(cfg);
              })
              .catch(function (err) {
                console.warn('Expivi: Failed to apply preset:', err);
              });
          });

        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          console.warn('Expivi: API not ready after timeout');
        }
      } catch (e) {
        if (attempts >= maxAttempts) clearInterval(interval);
      }
    }, 500);
  }

  // ─── Load saved configuration by bundle UUID ────────────
  // Fetches the saved config JSON from DigitalOcean Spaces and applies it via loadConfiguration().

  var SAVED_CONFIG_BASE = 'https://product-configurator.ams3.cdn.digitaloceanspaces.com/kingspan/';

  function loadSavedConfiguration(bundleUuid) {
    var win = iframe.contentWindow;
    var attempts = 0;
    var maxAttempts = 60; // 60 × 500ms = 30s

    var interval = setInterval(function () {
      attempts++;
      try {
        var apiReady   = win && win.expivi && typeof win.expivi.loadConfiguration === 'function';
        var hasOnReady = apiReady && win.expivi._events && win.expivi._events.onReady;

        if (hasOnReady) {
          clearInterval(interval);

          var sub = win.expivi._events.onReady.subscribe(function () {
            if (sub) sub.unsubscribe();

            fetch(SAVED_CONFIG_BASE + bundleUuid + '.json')
              .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
              })
              .then(function (config) {
                return win.expivi.loadConfiguration(config);
              })
              .catch(function (err) {
                console.warn('Expivi: Failed to load saved configuration:', err);
              });
          });

        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          console.warn('Expivi: API not ready after timeout');
        }
      } catch (e) {
        if (attempts >= maxAttempts) clearInterval(interval);
      }
    }, 500);
  }

  // ─── Late style overrides (injected after Vuetify) ───────
  // Vuetify injects <style> tags dynamically after onload.
  // We watch <head> for new additions and always re-append our override last.

  function injectLateStyles(doc, win) {
    if (!doc) return;

    function appendOverride() {
      var old = doc.getElementById('ksp-late-styles');
      if (old) old.remove();
      var s = doc.createElement('style');
      s.id = 'ksp-late-styles';
      s.textContent = [
        /* Step buttons gold — specificity 0-3-0 to beat Vuetify .v-application .primary--text */
        '.v-application .step-btn-next.v-btn, .v-application .step-btn-prev.v-btn { color: #C09A5D !important; }',
        /* Info icon container — match WooCommerce reference rgba(0,0,0,0.38) */
        '.step-header-icon { color: rgba(0, 0, 0, 0.38) !important; }',
        /* Original hidden ATC button */
        '.btn.expivi-add-to-cart { background-color: #134485 !important; color: #fff !important; border-radius: 30px !important; border: none !important; }',
        /* Custom bottom bar buttons — explicit styles to avoid inheritance */
        '.ksp-btn { display:inline-flex !important; align-items:center !important; justify-content:center !important; padding:0 20px !important; height:40px !important; border-radius:30px !important; font-size:14px !important; font-weight:600 !important; cursor:pointer !important; white-space:nowrap !important; text-decoration:none !important; }',
        '.ksp-btn--primary { background-color:#134485 !important; color:#fff !important; border:2px solid #134485 !important; }',
        '.ksp-btn--outline { background-color:transparent !important; color:#134485 !important; border:2px solid #134485 !important; }',
        '.ksp-btn--outline:hover { background-color:#134485 !important; color:#fff !important; }'
      ].join('\n');
      doc.head.appendChild(s);
    }

    appendOverride();

    // Re-append whenever Vuetify injects a new <style> into <head>
    var headObs = new win.MutationObserver(function (mutations) {
      var hasNew = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeName === 'STYLE' && n.id !== 'ksp-late-styles';
        });
      });
      if (hasNew) appendOverride();
    });
    headObs.observe(doc.head, { childList: true });

    // Stop watching after 15s (Vuetify is done by then)
    win.setTimeout(function () { headObs.disconnect(); }, 15000);
  }

  // ─── USP row injection ────────────────────────────────────

  function injectUspRow(doc) {
    if (!doc) return;
    if (doc.querySelector('.usp-row')) return;
    // Insert inside configurator-container, at the bottom
    var container = doc.querySelector('.configurator-container');
    if (!container) return;
    var usp = doc.createElement('div');
    usp.className = 'usp-row';
    usp.innerHTML = [
      '<div class="usp-row-column"><b>WaterMark Certified</b></div>',
      '<hr>',
      '<div class="usp-row-column">20 Year Corrosion Warranty</div>',
      '<hr>',
      '<div class="usp-row-column">10 Year Construction Warranty</div>'
    ].join('');
    container.appendChild(usp);
  }

  // ─── Bottom bar injection (price + qty + ATC + Save Design) ──────

  function injectBottomBar(doc, win) {
    if (!doc) return;
    if (doc.querySelector('.ksp-bottom-bar')) return;

    var bottomContent = doc.querySelector('.bottom-content');
    if (!bottomContent) return;

    // Build the bar — two rows matching WooCommerce reference:
    //   Row 1: Expivi price (moved here natively)
    //   Row 2: qty selector + Add to Cart + Save Design
    var bar = doc.createElement('div');
    bar.className = 'ksp-bottom-bar';
    bar.innerHTML = [
      '<div class="ksp-bottom-price"></div>',
      '<div class="ksp-bottom-actions">',
      '  <div class="ksp-qty-wrap">',
      '    <button class="ksp-qty-btn" id="ksp-qty-minus" type="button">&#x2212;</button>',
      '    <input  class="ksp-qty-input" id="ksp-qty-value" type="number" value="1" min="1" max="99">',
      '    <button class="ksp-qty-btn" id="ksp-qty-plus"  type="button">&#x2B;</button>',
      '  </div>',
      '  <button class="ksp-btn ksp-btn--primary" id="ksp-add-to-cart"  type="button">Add to Cart</button>',
      '  <button class="ksp-btn ksp-btn--outline"  id="ksp-save-design" type="button">Save Design</button>',
      '</div>'
    ].join('');

    // Hide the original bottom-content (inside viewer)
    bottomContent.style.display = 'none';

    // Append bar to the configurator-container (right panel), after USP row if present
    var confContainer = doc.querySelector('.configurator-container');
    if (confContainer) {
      confContainer.appendChild(bar);
    } else {
      bottomContent.parentElement.insertBefore(bar, bottomContent);
    }

    // Move Expivi's own price element into the price row so Expivi keeps managing it
    var priceEl = doc.querySelector('.expivi-product-price');
    if (priceEl) {
      bar.querySelector('.ksp-bottom-price').appendChild(priceEl);
    }

    // On mobile (<=600px) the qty stepper + both buttons don't fit on one row, so
    // dock the qty next to the price (top row) and leave the buttons full-width
    // below. On larger screens keep the original single actions row untouched.
    var qtyWrap = bar.querySelector('.ksp-qty-wrap');
    var priceRow = bar.querySelector('.ksp-bottom-price');
    var actionsRow = bar.querySelector('.ksp-bottom-actions');
    var mq = win.matchMedia('(max-width:600px)');
    function placeQty(m) {
      if (m.matches) priceRow.appendChild(qtyWrap);
      else actionsRow.insertBefore(qtyWrap, actionsRow.firstChild);
    }
    placeQty(mq);
    if (mq.addEventListener) mq.addEventListener('change', placeQty);
    else if (mq.addListener) mq.addListener(placeQty);

    // Quantity +/-
    bar.querySelector('#ksp-qty-minus').addEventListener('click', function () {
      var inp = bar.querySelector('#ksp-qty-value');
      var v = parseInt(inp.value, 10) || 1;
      if (v > 1) inp.value = v - 1;
    });
    bar.querySelector('#ksp-qty-plus').addEventListener('click', function () {
      var inp = bar.querySelector('#ksp-qty-value');
      var v = parseInt(inp.value, 10) || 1;
      inp.value = v + 1;
    });

    // Add to Cart.
    // 1) Show Summary modal listing the configuration (mirrors WooCommerce reference);
    //    only proceed to the real cart add when the user confirms.
    // 2) Expivi's native add-to-cart ALWAYS adds quantity 1 and ignores our stepper, and
    //    its post-add redirect to "/cart" happens INSIDE the srcdoc iframe (blocked by CSP
    //    frame-ancestors 'none' → broken page). So we:
    //      a) snapshot the cart, b) fire the native add (adds 1 of the configured replica),
    //      c) poll until the new/updated line appears, d) correct that line's quantity to the
    //         chosen amount via /cart/change.js, e) hand off to Shopify (send TOP window to /cart).
    //    An "Adding to cart…" overlay covers the few seconds of replica creation.
    bar.querySelector('#ksp-add-to-cart').addEventListener('click', function () {
      var addBtn = bar.querySelector('#ksp-add-to-cart');
      if (addBtn.getAttribute('data-busy') === '1') return;
      var qty = parseInt(bar.querySelector('#ksp-qty-value').value, 10) || 1;

      showSummaryModal(doc, win, function proceedToCart() {
        addBtn.setAttribute('data-busy', '1');
        showAddingOverlay(doc);

        function snapshot() {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              var m = {}; (c.items || []).forEach(function (it) { m[it.key] = it.quantity; });
              return { count: c.item_count || 0, map: m };
            })
            .catch(function () { return { count: 0, map: {} }; });
        }
        function goToCart() { (window.top || window).location.href = '/cart'; }
        function fail() { hideAddingOverlay(doc); addBtn.removeAttribute('data-busy'); }

        snapshot().then(function (before) {
          var origBtn = doc.querySelector('.expivi-add-to-cart');
          if (origBtn) origBtn.click();
          var tries = 0;
          var poll = setInterval(function () {
            tries++;
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                if (!c || c.item_count <= before.count) {
                  if (tries >= 40) { clearInterval(poll); fail(); } // ~20s safety net
                  return;
                }
                clearInterval(poll);
                // the line the native add created/updated = the one whose qty grew
                var target = null;
                (c.items || []).forEach(function (it) {
                  if (it.quantity > (before.map[it.key] || 0)) target = it;
                });
                if (target && qty > 1) {
                  // native already added 1 → set absolute total = previous + chosen qty
                  var desired = (before.map[target.key] || 0) + qty;
                  fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: target.key, quantity: desired })
                  }).then(goToCart).catch(goToCart);
                } else {
                  goToCart();
                }
              })
              .catch(function () {
                if (tries >= 40) { clearInterval(poll); fail(); }
              });
          }, 500);
        });
      });
    });

    // Save Design — open modal form
    bar.querySelector('#ksp-save-design').addEventListener('click', function () {
      openSaveDesignModal(doc, win);
    });
  }

  // ─── Save Design modal ────────────────────────────────────
  // Form collects user data, then calls expivi.saveConfiguration()
  // and shows a Congratulations message.

  // Every Save Design gets its own id (file name in Spaces and ?configuration= in the email link).
  // A design reopened from its link keeps the viewer's bundle_uuid; reusing it would overwrite the
  // earlier saved file, so an older email would open the newer design.
  function newSavedDesignId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function openSaveDesignModal(doc, win) {
    // Don't re-inject if already open
    if (doc.getElementById('ksp-save-modal')) {
      doc.getElementById('ksp-save-modal').style.display = 'flex';
      return;
    }

    var overlay = doc.createElement('div');
    overlay.id = 'ksp-save-modal';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;font-family:Kumbh Sans,sans-serif;';

    overlay.innerHTML = [
      '<div style="background:#EFF0F7;border-radius:20px;width:460px;max-width:92vw;max-height:90vh;overflow-y:auto;position:relative;">',
      '  <div style="padding:30px 30px 0;">',
      '    <div style="display:flex;justify-content:space-between;align-items:center;">',
      '      <span style="font-family:Roboto Slab,serif;font-size:22px;font-weight:900;color:#090b3b;">Save My Design</span>',
      '      <span id="ksp-save-close" style="cursor:pointer;font-size:14px;color:#4B4F58;font-weight:600;">CLOSE</span>',
      '    </div>',
      '  </div>',
      '  <form id="ksp-save-form" style="padding:20px 30px;">',
      '    <label style="display:block;color:#4B4F58;padding:8px 0 4px;font-size:14px;">Email address<abbr style="color:red;">*</abbr></label>',
      '    <input type="email" name="email" required style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;">',
      '    <label style="display:block;color:#4B4F58;padding:8px 0 4px;font-size:14px;">Contact number<abbr style="color:red;">*</abbr></label>',
      '    <input type="text" name="contact" required pattern="^[0-9+ ]*$" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;">',
      '    <label style="display:block;color:#4B4F58;padding:8px 0 4px;font-size:14px;">Name<abbr style="color:red;">*</abbr></label>',
      '    <input type="text" name="name" required style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;">',
      '    <label style="display:block;color:#4B4F58;padding:8px 0 4px;font-size:14px;">Postcode<abbr style="color:red;">*</abbr></label>',
      '    <input type="text" name="postcode" required pattern="^[0-9]*$" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;">',
      '    <label style="display:block;color:#4B4F58;padding:8px 0 4px;font-size:14px;">Suburb<abbr style="color:red;">*</abbr></label>',
      '    <input type="text" name="suburb" required style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;">',
      '    <label style="display:block;color:#4B4F58;padding:8px 0 4px;font-size:14px;">State</label>',
      '    <select name="state" style="width:100%;padding:10px;border:1px solid #ccc;border-radius:4px;font-size:14px;box-sizing:border-box;background:#fff;">',
      '      <option value="Australian Capital Territory">Australian Capital Territory</option>',
      '      <option value="New South Wales" selected>New South Wales</option>',
      '      <option value="Northern Territory">Northern Territory</option>',
      '      <option value="Queensland">Queensland</option>',
      '      <option value="South Australia">South Australia</option>',
      '      <option value="Tasmania">Tasmania</option>',
      '      <option value="Victoria">Victoria</option>',
      '      <option value="Western Australia">Western Australia</option>',
      '    </select>',
      '    <p id="ksp-save-error" style="color:red;font-size:13px;display:none;margin:8px 0 0;"></p>',
      '    <div id="ksp-save-loader" style="display:none;text-align:center;padding:16px 0;">',
      '      <div style="width:32px;height:32px;border:3px solid #EFF0F7;border-top-color:#C09A5D;border-radius:50%;animation:expivi-spin 0.8s linear infinite;margin:0 auto;"></div>',
      '    </div>',
      '  </form>',
      '  <div style="padding:0 30px 30px;">',
      '    <button id="ksp-save-submit" type="button" style="width:100%;padding:14px;background:#134485;color:#fff;border:none;border-radius:30px;font-size:15px;font-weight:600;cursor:pointer;font-family:Kumbh Sans,sans-serif;">Save Your Tank Design and Get A Quote</button>',
      '  </div>',
      '</div>'
    ].join('');

    doc.body.appendChild(overlay);

    // Close handlers
    doc.getElementById('ksp-save-close').addEventListener('click', function () {
      overlay.style.display = 'none';
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.style.display = 'none';
    });

    // Submit handler
    doc.getElementById('ksp-save-submit').addEventListener('click', function () {
      var form = doc.getElementById('ksp-save-form');
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var errorEl = doc.getElementById('ksp-save-error');
      var loader = doc.getElementById('ksp-save-loader');
      var submitBtn = doc.getElementById('ksp-save-submit');
      errorEl.style.display = 'none';
      loader.style.display = 'block';
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.6';

      // Collect user data
      var formData = {};
      var inputs = form.querySelectorAll('input, select');
      inputs.forEach(function (inp) { formData[inp.name] = inp.value; });

      // Save configuration via Expivi API
      var savePromise;
      if (win.expivi && typeof win.expivi.saveConfiguration === 'function') {
        savePromise = win.expivi.saveConfiguration();
      } else {
        savePromise = Promise.resolve(null);
      }

      savePromise.then(function (configData) {
        // Extract attributes using shared utility
        var extracted = window.ExpiviEmailUtils.extract(configData);

        // Send to make.com webhook
        var webhookUrl = 'https://hook.eu2.make.com/oe2b7ff9x8obmfpfutvu2tskenz2ifq9';
        return fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            contact: formData.contact,
            postcode: formData.postcode,
            suburb: formData.suburb,
            state: formData.state,
            page_url: window.location.origin + window.location.pathname,
            bundle_uuid: newSavedDesignId(),
            attributes_html: extracted.attributesHtml,
            attributes_text: extracted.attributesText,
            // Send the configuration as a JSON STRING, not an object. The make.com scenario
            // writes this field straight into a text file ("Create a File from Text") and uploads
            // it to DigitalOcean; a nested object/collection can't be serialised to text there
            // and ends up stored as the literal "undefined", breaking "View your saved tank".
            configuration: (typeof configData === 'string' ? configData : JSON.stringify(configData))
          })
        });
      }).then(function () {
        // Show success
        loader.style.display = 'none';
        overlay.querySelector('div').innerHTML = [
          '<div style="padding:30px;">',
          '  <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">',
          '    <span style="font-family:Roboto Slab,serif;font-size:22px;font-weight:900;color:#134485;">Congratulations</span>',
          '    <span id="ksp-success-close" style="cursor:pointer;font-size:14px;color:#4B4F58;font-weight:600;">CLOSE</span>',
          '  </div>',
          '  <p style="color:#4B4F58;font-size:15px;line-height:1.6;">Thank you for submitting your tank design. One of our friendly team members will be in touch soon.</p>',
          '  <button id="ksp-start-over" type="button" style="width:100%;padding:14px;background:transparent;color:#134485;border:2px solid #134485;border-radius:30px;font-size:15px;font-weight:600;cursor:pointer;margin-top:16px;font-family:Kumbh Sans,sans-serif;">Start over</button>',
          '</div>'
        ].join('');

        doc.getElementById('ksp-success-close').addEventListener('click', function () {
          overlay.style.display = 'none';
        });
        doc.getElementById('ksp-start-over').addEventListener('click', function () {
          overlay.style.display = 'none';
          if (win.location) win.location.reload();
        });
      }).catch(function (err) {
        console.error('Save Design error:', err);
        loader.style.display = 'none';
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
        errorEl.textContent = 'Failed to save design. Please try again.';
        errorEl.style.display = 'block';
      });
    });
  }

  // ─── Viewer UI buttons (Model + AR) ──────────────────────
  // Ported from WooCommerce xpv-custom.js.
  // Injected into the iframe's #viewer-container after the 3D canvas loads.
  // Environment button excluded per ticket (not needed).

  function injectViewerButtons(doc, win) {
    if (!doc) return;
    var attempts = 0;
    var maxAttempts = 60; // 30s

    var interval = win.setInterval(function () {
      attempts++;
      var viewerContainer = doc.getElementById('expivi-viewer-container') || doc.getElementById('viewer-container');
      var canvas = doc.querySelector('canvas');
      if (!viewerContainer || !canvas) {
        if (attempts >= maxAttempts) win.clearInterval(interval);
        return;
      }
      if (doc.querySelector('.iconsUI')) { win.clearInterval(interval); return; } // already injected
      win.clearInterval(interval);

      var icons = doc.createElement('div');
      icons.className = 'iconsUI';
      icons.style.position = 'fixed';
      icons.style.top = '20px';
      icons.style.left = '20px';
      icons.style.margin = '0';
      icons.innerHTML = [
        // Environment
        '<a class="ui-button singleIcons" id="bgButton" style="cursor:pointer;">',
        '  <span class="ui-icon-svg"><svg fill="none" stroke="white" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="18" height="18">',
        '    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></path>',
        '  </svg></span>',
        '  <span class="ui-text" style="color:white !important;">Environment</span>',
        '</a>',
        // Model (3D Guy)
        '<a class="ui-button singleIcons" id="modelButton" style="cursor:pointer;">',
        '  <span class="ui-icon-svg"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124.189 132.243" fill="white" width="18" height="18">',
        '    <path stroke-width="1.25" d="m62.096 8.5859c-5.208 0-9.424 4.2191-9.424 9.4261 0.001 5.203 4.217 9.424 9.424 9.424 5.202 0 9.422-4.221 9.422-9.424 0-5.208-4.22-9.4261-9.422-9.4261zm-10.41 21.268c-6.672 0-12.131 5.407-12.131 12.07v29.23c0 2.275 1.791 4.123 4.07 4.123 2.28 0 4.127-1.846 4.127-4.123v-26.355h2.102s0.048 68.811 0.048 73.331c0 3.05 2.478 5.53 5.532 5.53 3.052 0 5.525-2.48 5.525-5.53v-42.581h2.27v42.581c0 3.05 2.473 5.53 5.531 5.53 3.054 0 5.549-2.48 5.549-5.53v-73.331h2.127v26.355c0 2.275 1.85 4.123 4.126 4.123 2.28 0 4.073-1.846 4.073-4.123v-29.23c0-6.663-5.463-12.07-12.129-12.07h-20.82z"/>',
        '  </svg></span>',
        '  <span class="ui-text" style="color:white !important;">Model</span>',
        '</a>',
        // AR
        '<a class="ui-button singleIcons" id="arButton" style="cursor:pointer;">',
        '  <span class="ui-icon-svg"><svg viewBox="8 3 26 30" width="18" height="18" style="stroke:white;fill:none;stroke-width:2;stroke-linejoin:round;stroke-linecap:round;">',
        '    <path d="M21 17L10 11L21 5L32 11L21 17L32 11V24L21 31V17V31L10 24V11L21 17Z"></path>',
        '  </svg></span>',
        '  <span class="ui-text" style="color:white !important;">Augmented Reality</span>',
        '</a>'
      ].join('');
      viewerContainer.appendChild(icons);

      // Environment toggle
      var bgOn = false;
      doc.getElementById('bgButton').addEventListener('click', function () {
        bgOn = !bgOn;
        var btn = doc.getElementById('bgButton');
        if (bgOn) {
          win.expivi.setProductAttributeByKey('att-background', 'att-background-on');
          btn.classList.add('ui-button-active');
        } else {
          win.expivi.setProductAttributeByKey('att-background', 'att-background-off');
          btn.classList.remove('ui-button-active');
        }
      });

      // Model toggle
      var stickmanOn = false;
      doc.getElementById('modelButton').addEventListener('click', function () {
        stickmanOn = !stickmanOn;
        var btn = doc.getElementById('modelButton');
        if (stickmanOn) {
          win.expivi.setProductAttributeByKey('att-person', 'att-person-on');
          btn.classList.add('ui-button-active');
        } else {
          win.expivi.setProductAttributeByKey('att-person', 'att-person-off');
          btn.classList.remove('ui-button-active');
        }
      });

      // AR — triggers Expivi's hidden native AR button
      doc.getElementById('arButton').addEventListener('click', function () {
        var nativeAr = doc.getElementById('xpv-toolbar-item-web-ar');
        if (nativeAr) nativeAr.click();
      });
    }, 500);
  }

  // ─── View in 3D: show only Region + Colour steps ─────────
  // Waits for the Vuetify stepper to render, then:
  //   1. Hides every step whose header is NOT "Choose region" or "Colour"
  //   2. Sets editable + complete on visible steps so the user can click freely

  var VIEW_STEPS = ['choose region', 'colour'];

  function filterStepsForViewMode(doc, win) {
    if (!doc) return;
    var attempts = 0;
    var maxAttempts = 40; // 40 × 500ms = 20s

    var interval = win.setInterval(function () {
      attempts++;
      var stepContainers = doc.querySelectorAll('.v-stepper--vertical > .container');
      if (stepContainers.length === 0) {
        if (attempts >= maxAttempts) win.clearInterval(interval);
        return;
      }
      win.clearInterval(interval);

      stepContainers.forEach(function (container) {
        var header = container.querySelector('.step-header-name');
        var name = header ? header.textContent.trim().toLowerCase() : '';
        var keep = VIEW_STEPS.some(function (s) { return name.indexOf(s) !== -1; });
        if (!keep) {
          container.classList.add('ksp-view-hidden');
        }
      });

    }, 500);
  }

  // ─── Modal open/close ─────────────────────────────────────

  function showLoading() {
    if (loadingEl) {
      loadingEl.style.display = 'flex';
      loadingEl.innerHTML = '<div class="expivi-spinner"></div><p>Loading 3D configurator...</p>';
    }
    iframe.style.display = 'none';
  }

  function hideLoading() {
    if (loadingEl) loadingEl.style.display = 'none';
    iframe.style.display = 'block';
  }

  // "Adding to cart…" overlay shown inside the configurator iframe while the native
  // add + replica/variant creation runs (a few seconds), so the click doesn't feel frozen.
  function showAddingOverlay(doc) {
    if (!doc || doc.getElementById('ksp-adding-overlay')) return;
    if (!doc.getElementById('ksp-adding-style')) {
      var st = doc.createElement('style');
      st.id = 'ksp-adding-style';
      st.textContent = '@keyframes ksp-spin{to{transform:rotate(360deg)}}';
      doc.head.appendChild(st);
    }
    var ov = doc.createElement('div');
    ov.id = 'ksp-adding-overlay';
    ov.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(255,255,255,.88);display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:Kumbh Sans,Helvetica,Arial,sans-serif;';
    ov.innerHTML = '<div style="width:46px;height:46px;border:4px solid #d9dbe4;border-top-color:#134485;border-radius:50%;animation:ksp-spin .8s linear infinite;"></div>' +
                   '<p style="margin-top:16px;color:#134485;font-weight:600;font-size:16px;">Adding to cart…</p>';
    doc.body.appendChild(ov);
  }

  function hideAddingOverlay(doc) {
    if (!doc) return;
    var ov = doc.getElementById('ksp-adding-overlay');
    if (ov) ov.remove();
  }

  // ─── Summary modal (Configuration overview) ────────────────
  // Mirrors the WooCommerce reference: shows the user's selections in a list
  // before committing to Add to Cart. Built from configData via ExpiviEmailUtils.

  function showSummaryModal(doc, win, onConfirm) {
    if (!doc) return;
    if (doc.getElementById('ksp-summary-overlay')) return;

    // Inject styles once
    if (!doc.getElementById('ksp-summary-style')) {
      var st = doc.createElement('style');
      st.id = 'ksp-summary-style';
      st.textContent = [
        '#ksp-summary-overlay { position:fixed; inset:0; z-index:99998; background:rgba(0,0,0,.45); display:flex; align-items:center; justify-content:center; padding:20px; font-family:Kumbh Sans,Helvetica,Arial,sans-serif; }',
        '.ksp-summary-modal { background:#fff; border-radius:8px; width:100%; max-width:1000px; max-height:90vh; display:flex; flex-direction:column; overflow:hidden; box-shadow:0 20px 60px rgba(0,0,0,.3); }',
        '.ksp-summary-head { display:flex; align-items:center; justify-content:space-between; padding:18px 28px; border-bottom:1px solid #eee; }',
        '.ksp-summary-title { font-family:Roboto Slab,serif; font-size:20px; font-weight:700; color:#134485; margin:0; }',
        '.ksp-summary-close { background:none; border:none; font-size:28px; line-height:1; color:#888; cursor:pointer; padding:0 4px; }',
        '.ksp-summary-close:hover { color:#134485; }',
        // Body becomes a 2-column grid: table left, product image right
        '.ksp-summary-body { padding:18px 28px; overflow-y:auto; flex:1 1 auto; color:#333; font-size:14px; display:grid; grid-template-columns:1fr 320px; gap:24px; align-items:start; }',
        '.ksp-summary-config { min-width:0; }',
        '.ksp-summary-preview { display:flex; align-items:center; justify-content:center; background:#f7f8fa; border-radius:6px; padding:16px; min-height:280px; }',
        '.ksp-summary-preview img { max-width:100%; max-height:340px; object-fit:contain; display:block; }',
        '.ksp-summary-preview-empty { color:#888; font-size:13px; }',
        '.ksp-summary-body ul { margin:0; padding-left:20px; }',
        '.ksp-summary-body li { padding:4px 0; }',
        '.ksp-summary-body table { width:100%; border-collapse:collapse; }',
        '.ksp-summary-body table td:first-child { font-weight:600; color:#555; padding:8px 12px; border-bottom:1px solid #eee; }',
        '.ksp-summary-body table td:last-child { color:#333; padding:8px 12px; border-bottom:1px solid #eee; }',
        '.ksp-summary-empty { color:#888; padding:20px 0; text-align:center; }',
        '.ksp-summary-actions { padding:18px 28px; border-top:1px solid #eee; display:flex; gap:12px; justify-content:flex-end; }',
        '.ksp-summary-btn { padding:0 24px; height:42px; border-radius:30px; font-size:14px; font-weight:600; cursor:pointer; border:2px solid #134485; }',
        '.ksp-summary-btn--outline { background:transparent; color:#134485; }',
        '.ksp-summary-btn--outline:hover { background:#134485; color:#fff; }',
        '.ksp-summary-btn--primary { background:#134485; color:#fff; }',
        '.ksp-summary-loading { display:flex; align-items:center; justify-content:center; padding:40px 0; color:#134485; font-weight:600; grid-column:1 / -1; }',
        // Mobile: stack vertically — table first, product image after
        '@media (max-width: 768px) {',
        '  .ksp-summary-body { grid-template-columns:1fr; gap:16px; padding:14px 18px; }',
        '  .ksp-summary-config { order:1; }',
        '  .ksp-summary-preview { order:2; min-height:220px; padding:12px; }',
        '  .ksp-summary-preview img { max-height:240px; }',
        '  .ksp-summary-head { padding:14px 18px; }',
        '  .ksp-summary-actions { padding:14px 18px; }',
        '}'
      ].join('\n');
      doc.head.appendChild(st);
    }

    // Two modes:
    //   - With onConfirm callback: show "Cancel" + "Add to Cart" (used by ATC flow)
    //   - Without callback (preview): show only "Close" (used by Summary tab in stepbar)
    var previewOnly = typeof onConfirm !== 'function';

    // Snapshot the current 3D viewer as a data URL.
    // Primary: window.expivi.getScreenshot() — Expivi API that returns a JPEG
    //          data URL of the current render (works regardless of how WebGL was
    //          initialised, since Expivi renders into a separate framebuffer).
    // Fallback: canvas.toDataURL() — only works if preserveDrawingBuffer:true,
    //          which Expivi does NOT set by default, so this usually returns black.
    function captureViewerImage() {
      try {
        if (win.expivi && typeof win.expivi.getScreenshot === 'function') {
          var url = win.expivi.getScreenshot();
          if (typeof url === 'string' && url.indexOf('data:image') === 0) {
            return url;
          }
        }
      } catch (e) { /* API not ready — fall through */ }
      try {
        var canvases = doc.querySelectorAll('canvas');
        for (var i = 0; i < canvases.length; i++) {
          var c = canvases[i];
          if (!c.width || !c.height) continue;
          var url2 = c.toDataURL('image/png');
          if (url2 && url2.length > 'data:image/png;base64,'.length + 200) {
            return url2;
          }
        }
      } catch (e) { /* tainted canvas / WebGL no-readback — ignore */ }
      return '';
    }

    function build(configHtml, imgUrl) {
      var overlay = doc.createElement('div');
      overlay.id = 'ksp-summary-overlay';
      var actionsHtml = previewOnly
        ? '<button class="ksp-summary-btn ksp-summary-btn--primary" id="ksp-summary-confirm" type="button">Close</button>'
        : '<button class="ksp-summary-btn ksp-summary-btn--outline" id="ksp-summary-cancel" type="button">Cancel</button>' +
          '<button class="ksp-summary-btn ksp-summary-btn--primary" id="ksp-summary-confirm" type="button">Add to Cart</button>';
      var previewHtml = imgUrl
        ? '<img src="' + imgUrl + '" alt="Your tank">'
        : '<span class="ksp-summary-preview-empty">3D preview unavailable</span>';
      overlay.innerHTML = [
        '<div class="ksp-summary-modal" role="dialog" aria-modal="true" aria-labelledby="ksp-summary-title">',
        '  <div class="ksp-summary-head">',
        '    <h2 class="ksp-summary-title" id="ksp-summary-title">Configuration overview</h2>',
        '    <button class="ksp-summary-close" type="button" aria-label="Close">&times;</button>',
        '  </div>',
        '  <div class="ksp-summary-body">',
        '    <div class="ksp-summary-config">' + configHtml + '</div>',
        '    <div class="ksp-summary-preview">' + previewHtml + '</div>',
        '  </div>',
        '  <div class="ksp-summary-actions">' + actionsHtml + '</div>',
        '</div>'
      ].join('');
      doc.body.appendChild(overlay);

      function close() { overlay.remove(); }
      overlay.querySelector('.ksp-summary-close').addEventListener('click', close);
      var cancelBtn = overlay.querySelector('#ksp-summary-cancel');
      if (cancelBtn) cancelBtn.addEventListener('click', close);
      overlay.querySelector('#ksp-summary-confirm').addEventListener('click', function () {
        close();
        if (!previewOnly) onConfirm();
      });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }

    // Save current configuration via Expivi API to get the attribute list
    var savePromise;
    if (win.expivi && typeof win.expivi.saveConfiguration === 'function') {
      savePromise = win.expivi.saveConfiguration();
    } else {
      savePromise = Promise.resolve(null);
    }

    // Capture the 3D viewer BEFORE we overlay the modal (so the canvas is still
    // visible and freshly rendered). Some WebGL contexts won't yield a non-blank
    // PNG without preserveDrawingBuffer=true — captureViewerImage handles that
    // case by returning '' so we show a placeholder.
    var imgUrl = captureViewerImage();

    // Show modal immediately with a loading state for the config table
    build('<div class="ksp-summary-loading">Loading your configuration…</div>', imgUrl);

    savePromise.then(function (configData) {
      var html = '';
      try {
        var extracted = window.ExpiviEmailUtils && window.ExpiviEmailUtils.extract(configData);
        if (extracted && extracted.attributesHtml) {
          html = extracted.attributesHtml;
        }
      } catch (e) { /* fall through */ }
      if (!html) html = '<div class="ksp-summary-empty">No selections to show.</div>';

      var overlay = doc.getElementById('ksp-summary-overlay');
      if (!overlay) return; // user closed before save finished
      var cfgEl = overlay.querySelector('.ksp-summary-config');
      if (cfgEl) cfgEl.innerHTML = html;
    }).catch(function () {
      var overlay = doc.getElementById('ksp-summary-overlay');
      if (!overlay) return;
      var cfgEl = overlay.querySelector('.ksp-summary-config');
      if (cfgEl) cfgEl.innerHTML = '<div class="ksp-summary-empty">Could not load configuration.</div>';
    });
  }

  // Expose a preview-only entry point for other scripts (e.g. the Summary tab
  // in expivi-stepbar.js). Shows the same modal as Add to Cart, but the primary
  // action is "Close" — no cart side-effects.
  window.KingspanExpivi = window.KingspanExpivi || {};
  window.KingspanExpivi.previewSummary = function () {
    if (!iframe) return;
    var doc, win;
    try { doc = iframe.contentDocument; win = iframe.contentWindow; } catch (e) { return; }
    if (!doc || !win) return;
    showSummaryModal(doc, win, null);
  };

  /**
   * @param {boolean} fullscreen - true = Build in 3D (no preset), false = View in 3D (with preset)
   */
  function openModal(fullscreen) {
    if (!baseUrl) {
      console.warn('Expivi: No configurator URL found on page');
      return;
    }

    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Both modes use fullscreen modal
    if (modalInner) {
      modalInner.classList.add('expivi-modal--fullscreen');
    }

    showLoading();

    // CSS injected in "View in 3D" mode:
    //   - Hide bottom bar, tabs, nav buttons, and non-relevant steps
    //   - Flatten the stepper: no circles, no connectors, all visible contents stacked
    var viewOnlyCss = fullscreen ? '' : [
      '<style>',
      '.bottom-content { display: none !important; }',
      '.expiviWrapper { display: none !important; }',
      '.ksp-view-hidden { display: none !important; }',
      '.step-btn-next, .step-btn-prev { display: none !important; }',
      /* Remove step number circles */
      '.v-stepper__step__step { display: none !important; }',
      /* Remove step header icon (info) */
      '.step-header-icon { display: none !important; }',
      /* Remove vertical connector line and left margin */
      '.v-stepper--vertical .v-stepper__content { border-left: none !important; margin-left: 0 !important; padding-left: 12px !important; }',
      /* Force ALL step contents visible (hidden steps won\'t show — parent has display:none) */
      '.v-stepper__content { display: block !important; }',
      '.v-stepper__wrapper { height: auto !important; transition: none !important; }',
      /* Step header as simple section label */
      '.v-stepper__step { padding-left: 0 !important; cursor: default !important; }',
      /* Padding for the options panel so content doesn\'t touch edges */
      '.configurator-container { padding: 16px 20px !important; }',
      '</style>'
    ].join('');

    // CSS injected in "Build in 3D" (fullscreen) mode on the PDP modal:
    // fit the modal to the viewport height and scroll the OPTIONS panel internally,
    // so the whole document doesn't scroll and leave a scrollbar strip cutting the
    // right edge. Excluded on the standalone full-page builder (data-stepbar="1"),
    // which has its own layout + top step bar.
    var isStepbarPage = modal.getAttribute('data-stepbar') === '1';
    var fullscreenCss = (fullscreen && !isStepbarPage) ? [
      '<style>',
      '.expivi-page-container { height: 100vh !important; overflow: hidden !important; }',
      '.configurator-container { height: 100vh !important; overflow-y: auto !important; overflow-x: hidden !important; }',
      '.configurator-container::-webkit-scrollbar { width: 8px; }',
      '.configurator-container::-webkit-scrollbar-thumb { background: rgba(0,0,0,.25); border-radius: 4px; }',
      '</style>'
    ].join('') : '';

    fetch(baseUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var inject = '<base href="' + window.location.origin + '/">' +
          (cssUrl ? '<link rel="stylesheet" href="' + cssUrl + '">' : '') +
          viewOnlyCss +
          fullscreenCss;

        if (html.indexOf('<head>') !== -1) {
          html = html.replace('<head>', '<head>' + inject);
        } else if (html.indexOf('<HEAD>') !== -1) {
          html = html.replace('<HEAD>', '<HEAD>' + inject);
        } else {
          html = '<!DOCTYPE html><html><head>' + inject + '</head><body>' + html + '</body></html>';
        }

        iframe.srcdoc = html;
        iframe.onload = function () {
          hideLoading();
          // Apply the SKU preset in BOTH "View" and "Build" modes,
          // but never clobber a saved-config auto-open (?configuration=).
          if (presetKey && !(fullscreen && savedConfig)) {
            applyPreset(presetKey);
          }
          // Load saved configuration if opened from email link
          if (fullscreen && savedConfig) {
            loadSavedConfiguration(savedConfig);
          }
          if (!fullscreen) {
            filterStepsForViewMode(iframe.contentDocument, iframe.contentWindow);
          }
          if (fullscreen) {
            injectViewerButtons(iframe.contentDocument, iframe.contentWindow);
            injectUspRow(iframe.contentDocument);
            injectBottomBar(iframe.contentDocument, iframe.contentWindow);
          }
          injectLateStyles(iframe.contentDocument, iframe.contentWindow);
        };
      })
      .catch(function (err) {
        console.error('Expivi: Failed to load configurator:', err);
        if (loadingEl) {
          loadingEl.innerHTML = '<p style="color:#666;font-size:14px;">Failed to load configurator.<br>Please try again.</p>';
        }
      });
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    iframe.srcdoc = '';
    iframe.onload = null;
    if (modalInner) modalInner.classList.remove('expivi-modal--fullscreen');
  }

  // ─── Positioning ──────────────────────────────────────────

  var buttonsRow = document.querySelector('.expivi-buttons-row');
  var priceEl    = document.querySelector('product-price');
  if (buttonsRow && priceEl) {
    var priceWrapper = document.createElement('div');
    priceWrapper.className = 'expivi-price-buttons-row';
    priceEl.parentElement.insertBefore(priceWrapper, priceEl);
    priceWrapper.appendChild(priceEl);
    priceWrapper.appendChild(buttonsRow);
  }

  // ─── Event listeners ──────────────────────────────────────

  if (buildTrigger) buildTrigger.addEventListener('click', function () { openModal(true); });
  if (viewTrigger)  viewTrigger.addEventListener('click',  function () { openModal(false); });

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  // ─── Auto-open from saved configuration link ──────────────
  // When the URL contains ?configuration=UUID (from the email link),
  // append it to baseUrl and auto-open the Build in 3D modal.
  var pageParams = new URLSearchParams(window.location.search);
  var savedConfig = pageParams.get('configuration');
  if (savedConfig && baseUrl) {
    // Auto-open Build in 3D modal — savedConfig is used inside openModal
    // to call loadSavedConfiguration() after the iframe loads
    setTimeout(function () { openModal(true); }, 800);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  }); 
})();
